import type { SupabaseClient } from "@supabase/supabase-js";

/** Session bearer headers without Nuxt composables (safe inside async callbacks). */
export async function getSupabaseAuthHeaders(
  supabase: SupabaseClient,
): Promise<Record<string, string>> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) return {};
  return { Authorization: `Bearer ${session.access_token}` };
}

/**
 * Headers for server API routes when the session is not in cookies
 * (@nuxtjs/supabase with useSsrCookies: false).
 */
export function useSupabaseAuthHeaders() {
  const supabase = useSupabaseClient();

  return () => getSupabaseAuthHeaders(supabase);
}
